import React, { ReactElement } from 'react';
import UDInput, { UDInputProps } from './component';
import classNames from 'classnames';
import UDPasswordInput from './component/password';
import { UDFormComponentProps } from '../types';
import UDFormFieldWrapper from '../../wrapper';

type Props = UDFormComponentProps &
  Omit<UDInputProps, 'hasError' | 'valid' | 'ref'> & {
    inputComponent?: (props: any) => ReactElement<any, any> | null;
  };

const UDFormInput = (
  props: Props,
  ref: React.ForwardedRef<HTMLInputElement>
) => {
  const {
    name,
    containerProps,
    label,
    required,
    labelProps,
    inputComponent,
    ...otherInputProps
  } = props;

  const Component = inputComponent
    ? inputComponent
    : otherInputProps.type === 'password'
    ? UDPasswordInput
    : UDInput;

  return (
    <UDFormFieldWrapper
      name={name}
      containerProps={containerProps}
      label={label}
      labelProps={labelProps}
      required={required}
    >
      {({ field, meta }) => (
        <Component
          ref={ref}
          {...otherInputProps}
          wrapperProps={{
            ...otherInputProps.wrapperProps,
            className: classNames(
              'w-100',
              otherInputProps.wrapperProps?.className
            ),
          }}
          {...field}
          hasError={!!meta.error}
          valid={!meta.error && meta.touched && meta.value}
        />
      )}
    </UDFormFieldWrapper>
  );
};

export default UDFormInput;
